<template>
  <nav class="legacy-shell-placeholder"></nav>
</template>

<style scoped>
.legacy-shell-placeholder {
  display: none;
}
</style>
